// @ts-strict-ignore
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from '@emotion/styled';

import { Text } from '../../components/text';
import { SubjectToolkits } from './subjectToolkits';
import { useAppDispatch, useAppSelector } from '../../redux';
import { SubjectTree } from '../../components/SubjectTree';
import { PageContainer } from '../../components/pageContainer';
import { Header } from '../../components/header';
import { LeftNav } from '../../components/leftNav';
import { ActionBar } from '../../components/styles';
import { primary } from '../../utils/colors';
import { getDefinitions } from '../../redux/actions/module';
import { Spinner } from '../../components/Spinner';

export const title = 'Toolkits';
export const Toolkits: React.FC = () => {
  const query = new URLSearchParams(window.location.search);
  const debug = query.get('debug') ? true : false;

  const params = useParams();
  const dispatch = useAppDispatch();
  const classId = parseInt(params.classId);
  const modules = useAppSelector((state) => state.module.definitions.modules);
  const fetchingDefinitions = useAppSelector((state) => state.module.fetchingDefinitions);

  useEffect(() => {
    if (!fetchingDefinitions && Object.keys(modules).length === 0) dispatch(getDefinitions());
  }, []);

  const leafDataModuleList = new Set<string>();
  for (const module of modules) {
    if (module.alignedResourcesLink) leafDataModuleList.add(module.id);
  }

  if (fetchingDefinitions || Object.keys(modules).length == 0) {
    return (
      <PageContainer header={<Header />} leftNav={<LeftNav currentClassId={classId} />}>
        <ActionBar>
          <Text variant="lg2" color={primary} data-cy="toolkits-index-header-name">
            Toolkits
          </Text>
        </ActionBar>
        <Spinner label="Fetching toolkits ..." center />
      </PageContainer>
    );
  } else {
    return (
      <PageContainer header={<></>} leftNav={<LeftNav currentClassId={classId} />}>
        <Header />
        <ActionBar>
          <Text variant="lg2" color={primary} data-cy="toolkits-index-header-name">
            Toolkits
          </Text>
        </ActionBar>
        {debug &&
          modules.map((m) => (
            <Text variant={m.alignedResourcesLink ? 'nav' : 'not'} key={m.id}>
              {m.id}
            </Text>
          ))}
        <ButtonContainer>
          <StyledAnchor
            href="#"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                'https://docs.google.com/document/d/1Mrh062KycF1OW_xvqxpvCn-H-oBFUlrjFnGNkZ06jtE/edit?tab=t.0',
              );
            }}
          >
            Math Toolkit Landing Page
          </StyledAnchor>
          <StyledAnchor
            href="#"
            onClick={(event) => {
              event.preventDefault();
              window.open(
                'https://docs.google.com/document/d/1cwRKdRIdLWRj-eCCiA7kb80tpqe-2b-pV7zFhnD3c2k/edit?tab=t.0',
              );
            }}
          >
            Science Toolkit Landing Page
          </StyledAnchor>
        </ButtonContainer>
        <SubjectTree leafData={null} leafDataModuleList={leafDataModuleList} LeafComponent={SubjectToolkits} />
      </PageContainer>
    );
  }
};

const ButtonContainer = styled.div({
  display: 'flex',
  alignItems: 'left',
});

const StyledAnchor = styled.a({
  margin: '1em 2em 1em 2em',
  color: primary,
  display: 'block',
});
